const MAX_WINDOW_WIDTH = 500;
const BOTTOM_TABBAR_HEIGHT = 70;
const TOP_NAVIGATION_HEIGHT = 44;
const BOTTOMSHEET_HEADER_HEIGHT = 85;
const DEFAULT_MARGIN = 16;
const SCREEN_WIDTH = typeof window !== 'undefined' ? Math.min(window.innerWidth, 500) : 0;
const SCREEN_HEIGHT = typeof window !== 'undefined' ? window.innerHeight : 0;
const TITLE_HEADER_HEIGHT = 44;
const VIEW_AS_BANNER_HEIGHT = 41;
const CHAT_MESSAGE_INPUT_HEIGHT = 65;
const CHAT_EMOJI_AREA_SIZE = 30;
const CHAT_EMOJI_FONT_SIZE = 22;

const EMOJI_PICKER_HEIGHT = {
  LONG: 230,
  DEFAULT: 190,
  SHORT: 150,
};

const Z_INDEX = {
  TITLE_HEADER: 100,
  NOTI_PERMISSION_BANNER: 200,
  MODAL_CONTAINER: 1000,
  TOAST_CONTAINER: 2000,
  BOTTOM_TAB: 300,
  EMOJI_PICKER: 20,
  COMMENT_LIKES_POPUP: 1500,
  PROFILE_IMAGE_OVERLAY: 500,
  ALERT_DIALOG: 1600,
};

export {
  BOTTOM_TABBAR_HEIGHT,
  BOTTOMSHEET_HEADER_HEIGHT,
  DEFAULT_MARGIN,
  EMOJI_PICKER_HEIGHT,
  MAX_WINDOW_WIDTH,
  CHAT_EMOJI_AREA_SIZE,
  CHAT_EMOJI_FONT_SIZE,
  CHAT_MESSAGE_INPUT_HEIGHT,
  SCREEN_HEIGHT,
  SCREEN_WIDTH,
  TITLE_HEADER_HEIGHT,
  TOP_NAVIGATION_HEIGHT,
  VIEW_AS_BANNER_HEIGHT,
  Z_INDEX,
};
